import { render } from "./SystemAreasContent.vue?vue&type=template&id=db547f36&ts=true"
import script from "./SystemAreasContent.vue?vue&type=script&lang=ts"
export * from "./SystemAreasContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__